import { createContext } from "react";
import { getGlobal } from "../util/getGlobal";
const theGlobal = getGlobal();
const createNamedContext = (name, defaultValue) => {
    theGlobal.__geomecontexts = theGlobal.__geomecontexts || {};
    if (theGlobal.__geomecontexts[name])
        return theGlobal.__geomecontexts[name];
    const context = (theGlobal.__geomecontexts[name] = createContext(defaultValue));
    context.displayName = name;
    return context;
};
export { createNamedContext };
